package com.writerslab

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.cancel

/**
 * Minimal stand-in for androidx.lifecycle.ViewModel — the multiplatform
 * artifact pulls in too much for our needs. We just need a coroutine
 * scope tied to the screen lifetime.
 *
 * Compose HTML manages composition lifetime via the renderComposable root;
 * the app lives for the full page visit, so we don't need granular
 * disposal here. `clear()` is exposed for future onCleared-like hooks.
 */
abstract class BaseViewModel {
    protected val viewModelScope: CoroutineScope = MainScope()

    open fun clear() {
        viewModelScope.cancel()
    }
}
